// src/features/layout/entityPanelBadges.tsx
// Badge counts for entity-panel rail tabs. Hooks can't run conditionally per
// registered panel, so one headless component runs each panel's badge hook and
// writes results into a tiny store the icon strip reads.

import { useEffect } from 'react';
import { makeAutoObservable } from 'mobx';
import type { EntityContext } from '@/stores/EntityStore';
import { useEntityDiscussionBadge } from '@/features/chat/useEntityDiscussionBadge';

class PanelBadgeStore {
  counts = new Map<string, number>();
  constructor() { makeAutoObservable(this); }
  set(key: string, n: number) {
    if (this.counts.get(key) !== n) this.counts.set(key, n);
  }
  get(key: string): number { return this.counts.get(key) ?? 0; }
}

export const panelBadgeStore = new PanelBadgeStore();

export function EntityPanelBadges({ ctx }: { ctx: EntityContext | null }) {
  const discussionUnread = useEntityDiscussionBadge(ctx);
  useEffect(() => { panelBadgeStore.set('discussion', discussionUnread); }, [discussionUnread]);
  return null;
}
